import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import {
  PieChart,
  Pie,
  BarChart,
  Bar,
  LineChart,
  Line,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  Cell,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import ContentEngagementBarGraph from "../../components/ContentProviderDashboard/ContentEngagement";
import EngagementRateGraphByGender from "../../components/AdminProviderDashboard/Charts/EngagementRateByGender";
import AirlineConsumptionChart from "../../components/AdminProviderDashboard/Charts/AirlineConsumption";
import ContentCategoryBarChart from "../../components/AdminProviderDashboard/Charts/ContentCategoryChart";
import TotalContentProviders from "../../components/AdminProviderDashboard/Charts/TotalContentProviders";
import AgreementStatus from "../../components/AdminProviderDashboard/Charts/AgreementStatus";
import ContentInventoryHours from "../../components/AdminProviderDashboard/Charts/ContentInventoryHours";
import ContentStatus from "../../components/AdminProviderDashboard/Charts/ContentStatus";
import ContentConsumptionPerDevice from "../../components/AdminProviderDashboard/Charts/ContentConsumptionPerDevice";

const dataProviders = [
  { name: "Active Providers", value: 400 },
  { name: "Dormant Providers", value: 100 },
];

const dataAgreements = [
  { name: "Active Agreements", value: 300 },
  { name: "Expired Agreements", value: 200 },
];

const contenInventoryHours = [
  { name: "Active Content Hours", value: 1020 },
  { name: "Expired Content Hours", value: 450 },
];

// Demo data for Content Status Bar Chart
const dataContentStatus = [
  {
    name: "Pending for Approval",
    Count: 120,
  },
  {
    name: "Approved Content",
    Count: 150,
  },
  {
    name: "Deployed",
    Count: 100,
  },
  {
    name: "Sent for Feedback",
    Count: 50,
  },
];

const contentConsumptionPerDevice = [
  { name: "Mobile", value: 50, color: "#34baeb" },
  { name: "Tablet", value: 30, color: "#02de40" },
  { name: "Laptop", value: 20, color: "#fa07b1" },
];

// Demo data for Analytics Line Chart
const dataAnalytics = [
  { month: "Jan", EngagementRate: 65, AvgConsumptionDevice: 120 },
  { month: "Feb", EngagementRate: 70, AvgConsumptionDevice: 130 },
  { month: "Mar", EngagementRate: 75, AvgConsumptionDevice: 150 },
  { month: "Apr", EngagementRate: 80, AvgConsumptionDevice: 170 },
  { month: "May", EngagementRate: 85, AvgConsumptionDevice: 160 },
  { month: "Jun", EngagementRate: 90, AvgConsumptionDevice: 180 },
];

const Dashboard = () => {
  return (
    <>
      <Typography variant="h5" my={3}>
        Admin Dashboard
      </Typography>
      <Grid container spacing={3}>
        {/* Total Content Providers */}
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Typography textAlign={"center"} mb={4}>
                Total Content Providers
              </Typography>
              {/* <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  dataKey="value"
                  data={dataProviders}
                  outerRadius={80}
                  label
                >
                  {dataProviders.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={index === 0 ? "#05a61d" : "#cc024c"} // Assign colors here
                    />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer> */}
              <TotalContentProviders />
            </CardContent>
          </Card>
        </Grid>

        {/* Agreement Status */}
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Typography textAlign={"center"} mb={4}>
                Agreement Status
              </Typography>
              {/* <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  dataKey="value"
                  data={dataAgreements}
                  outerRadius={80}
                  label
                >
                  {dataAgreements.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={index === 0 ? "#fa7907" : "#a107fa"} // Assign colors here
                    />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer> */}

              <AgreementStatus />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Typography textAlign={"center"} mb={4}>
                Content Inventory (Hours)
              </Typography>
              {/* <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  dataKey="value"
                  data={contenInventoryHours}
                  outerRadius={80}
                  label
                >
                  {contenInventoryHours.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={index === 0 ? "#76c900" : "#c96b00"} // Assign colors here
                    />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer> */}
              <ContentInventoryHours />
            </CardContent>
          </Card>
        </Grid>

        {/* Content Status */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography textAlign={"center"} mb={4}>
                Content Status
              </Typography>
              {/* <ResponsiveContainer width="100%" height={300}>
              <BarChart data={dataContentStatus}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip
                  formatter={(value) => [`${value}`, "Number Of Contents"]}
                />
                <Legend formatter={(value) => "Number Of Contents"} />
                <Bar dataKey="Count" fill="#2b6bcc" />
              </BarChart>
            </ResponsiveContainer> */}

              <ContentStatus />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography textAlign={"center"} mb={4}>
                Engagement Bar Graph By Gender
              </Typography>
              <EngagementRateGraphByGender />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Typography textAlign={"center"} mb={4}>
                Content Consumption Per Device
              </Typography>
              {/* <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  dataKey="value"
                  data={contentConsumptionPerDevice}
                  outerRadius={80}
                  label
                >
                  {contentConsumptionPerDevice.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={entry.color} // Assign colors here
                    />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => `${value}%`} />
                <Legend />
              </PieChart>
            </ResponsiveContainer> */}
              <ContentConsumptionPerDevice />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Typography textAlign={"center"} mb={4}>
                Content Consumtion Per Airline
              </Typography>
              <AirlineConsumptionChart />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Typography textAlign={"center"} mb={4}>
                Total Time Spent Per Content Type
              </Typography>
              <ContentCategoryBarChart />
            </CardContent>
          </Card>
        </Grid>
        {/* Analytics */}
        {/* <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Analytics</Typography>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={dataAnalytics}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="EngagementRate"
                  stroke="#8884d8"
                />
                <Line
                  type="monotone"
                  dataKey="AvgConsumptionDevice"
                  stroke="#82ca9d"
                />
              </LineChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid> */}
      </Grid>
    </>
  );
};

export default Dashboard;
